module.exports = { id: "city", url: "/build/app/img/symbols.svg#city", viewBox: "", toString: function() { return this.url; } };